import { render, staticRenderFns } from "./SelectCoachModal.vue?vue&type=template&id=28c12dcf"
import script from "./SelectCoachModal.vue?vue&type=script&lang=js"
export * from "./SelectCoachModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports